import React from "react";
import { EvtQuickLinksCard } from "components/quicklinks/display-card";
import { useFetch } from "@/hooks/useFetch";
import { EvtHeader } from "components/header";
import { fetchQuickLinks } from "@/modules/home/api";

export default function QuickLinksGrid() {
    const { data: quickLinksData } = useFetch({
    queryKey: [],
    queryFn: () => fetchQuickLinks(),
  });
  if (!quickLinksData?.length) return null;
  return (
    <>
    <EvtHeader title="Quick Links" />
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 px-6">
      {quickLinksData.map((link) => (
        <EvtQuickLinksCard
          key={link.id}
          onClick={() => window.open(link.url, "_blank", "noopener,noreferrer")}
          label={link.label}
          description={link.description}
          url={link.url}
          favicon={link.favicon}
          className="cursor-pointer hover:shadow-lg transition-shadow duration-200"
        />
      ))}
    </div>
    </>
  );
}
